package com.appcreator.compose

import androidx.compose.runtime.Composable
import androidx.compose.runtime.State
import androidx.compose.runtime.mutableStateOf
import coil3.PlatformContext
import com.appcreator.blueprint.conditions.permission.CheckPermissionCondition
import okio.Path

@Composable
actual fun getPermissions(): State<Map<String, String>?> = mutableStateOf(
    CheckPermissionCondition.Permission.entries.associate {
        "permission-state-${it.name}" to CheckPermissionCondition.State.Granted.name
    }
)

@Composable
actual fun InAppNotificationWrapper(content: @Composable (() -> Unit)) {
    content()
}

actual fun imageCacheDirectory(context: PlatformContext): Path? = null